import moment from 'moment'

export default function (value, na=undefined) {
  // 03:32 pm => 15:32 (US => military)
  return value && value.trim() !== '' ? moment('2020-01-27 ' + value).format('HH:mm') : na
}
